"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var config_1 = require("../config");

var index_1 = __importDefault(require("../Icon/index"));

var InputNumber_1 = __importDefault(require("./InputNumber"));

var InputVariant;

(function (InputVariant) {
  InputVariant[InputVariant["White"] = 0] = "White";
  InputVariant[InputVariant["Grey"] = 1] = "Grey";
})(InputVariant = exports.InputVariant || (exports.InputVariant = {})); // This must be a class, because of Autocomplete input.
// Only class components can have `refs`


var Input =
/** @class */
function (_super) {
  __extends(Input, _super);

  function Input() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputRef = react_1.default.createRef();
    return _this;
  }

  Input.prototype.focus = function () {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  };

  Input.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        className = _a.className,
        iconStart = _a.iconStart,
        iconStop = _a.iconStop,
        style = _a.style,
        textEnd = _a.textEnd,
        _b = _a.variant,
        variant = _b === void 0 ? InputVariant.Grey : _b,
        rest = __rest(_a, ["label", "className", "iconStart", "iconStop", "style", "textEnd", "variant"]);

    var b = config_1.block('input');
    var cn = b({
      with_start_icon: !!iconStart,
      with_stop_icon: !!iconStop || !!textEnd,
      white: variant === InputVariant.White,
      grey: variant === InputVariant.Grey
    });
    var iconS = null;

    if (iconStart) {
      iconS = react_1.default.createElement(index_1.default, {
        icon: iconStart,
        className: "icon_start"
      });
    }

    var iconE = null;

    if (iconStop) {
      iconE = react_1.default.createElement(index_1.default, {
        icon: iconStop,
        className: "icon_stop"
      });
    }

    var textE = null;

    if (textEnd) {
      textE = react_1.default.createElement("span", {
        className: "icon_stop"
      }, textEnd);
    }

    var input = react_1.default.createElement("input", __assign({}, rest, {
      className: cn,
      ref: this.inputRef
    }));

    if (this.props.type === 'number') {
      input = react_1.default.createElement(InputNumber_1.default, __assign({}, rest, {
        className: cn,
        ref: this.inputRef
      }));
    }

    return react_1.default.createElement("div", {
      className: b('container'),
      style: style
    }, input, iconS, textE, iconE);
  };

  return Input;
}(react_1.default.Component);

exports.default = Input;